import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './filter-panel.scss?inline';

/**
 * Teleport-safe filter panel. Styles live in this element's shadow DOM, so they
 * stay intact when `sotbit-dropdown` moves the host into `sotbit-dropdown-content`.
 *
 * Scrolling is owned by `sotbit-dropdown-content`; this panel only lays out options.
 * Apply/reset belong in `slot="footer"` on the parent `sotbit-dropdown`.
 *
 * Light DOM:
 * - default: option controls / filter groups
 *
 * @property {'axis'|'stack'} variant - `axis` for one property, `stack` for collapsed toolbar
 */
export default class SotbitFilterPanel extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        variant: { type: String, reflect: true },
    };

    constructor() {
        super();
        this.variant = 'axis';
    }

    render() {
        return html`
            <div class="filter-panel" part="filter-panel">
                <div class="filter-panel__list" part="filter-panel__list">
                    <slot></slot>
                </div>
            </div>
        `;
    }
}
